export class Player {
    constructor() {
        this.wallet = 1000;
        this.shares = 0;
    }
}
